import React from "react";

export const ColorPicker = ({ onChange, value }) => {
  const colors = [
    { name: "Modern", primary: "#2563eb", secondary: "#7dd3fc" },
    { name: "Elegant", primary: "#18181b", secondary: "#e2e8f0" },
    { name: "Vibrant", primary: "#db2777", secondary: "#f472b6" },
    { name: "Natural", primary: "#15803d", secondary: "#86efac" },
  ];

  return (
    <div className="space-y-2">
      <label className="text-white text-sm">Color Scheme</label>
      <div className="flex gap-2">
        {colors.map((color) => (
          <button
            key={color.name}
            onClick={() => onChange(color)}
            className={`p-2 rounded-lg flex flex-col items-center ${
              value?.name === color.name ? "ring-2 ring-white" : ""
            }`}
          >
            <div className="flex gap-1">
              <div
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: color.primary }}
              />
              <div
                className="w-4 h-4 rounded-full"
                style={{ backgroundColor: color.secondary }}
              />
            </div>
            <span className="text-white text-xs mt-1">{color.name}</span>
          </button>
        ))}
      </div>
    </div>
  );
};
